function u(e, n) {
  document.addEventListener(e, n);
}
function c(e, n) {
  document.removeEventListener(e, n);
}
function i(e, n) {
  const t = new CustomEvent(e, { detail: n });
  document.dispatchEvent(t);
}
export {
  i as publish,
  u as subscribe,
  c as unsubscribe
};
